import axios, {AxiosError, AxiosInstance, AxiosResponse} from 'axios';
import { getBackendUrl } from '@config';
import posthog from 'posthog-js';

/**
 * HttpClient to extend to create an API client instance
 * @class
 * @abstract
 * @param baseURL: url parameter extension from the backend base URL
 */
export abstract class HttpClient {
  protected readonly instance: AxiosInstance;
  protected readonly withCredentials: boolean;
  private backendURL: string;

  public constructor(baseURL: string) {
    this.withCredentials = true;
    this.backendURL = getBackendUrl();

    this.instance = axios.create({
      baseURL: this.backendURL + baseURL,
      withCredentials: this.withCredentials
    });
    this._initializeResponseInterceptor();
  }

  private _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError
    );
  };

  private _handleResponse = (res: AxiosResponse) => res;

  protected _handleError = (error: AxiosError) => {
    // Track network errors
    if (!error.response) {
      posthog.capture('network_error', {
        error_message: error.message,
        error_code: error.code,
        config_url: error.config?.url,
        config_method: error.config?.method
      });
    } else {
      // Track API errors - COMMENTED OUT FOR NOW
      // posthog.capture('api_error', {
      //   error_message: error.message,
      //   status_code: error.response.status,
      //   status_text: error.response.statusText,
      //   api_url: error.config?.url,
      //   api_method: error.config?.method,
      //   response_data: error.response.data
      // });
    }
    
    console.error(error.message);
    return Promise.reject(error);
  }
}
